import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Table, Spin, Select, Tag } from "antd";
import {
  CloseCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import appStatic from "../../../../config/appStatic";
import appLabel from "../../../../config/appLabel";
import definedApi from "../../../../services/definedApi";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import DownloadTableButtons from "../../../../components/DownloadTableButtons";

import { rightAction } from "../../../../redux/actions";
import StatusSelect from "../../../../components/CustomStatusSelect";
// import { handleFlgStatus } from "../../../../components/facilities/AccountFacility";

const { Text } = Typography;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "Short Name",
    dataIndex: "shortName",
    sorter: (a, b) => a.shortName.localeCompare(b.shortName),
  },
  {
    title: "Currency",
    dataIndex: "currency",
    sorter: (a, b) => a["currency"].localeCompare(b["currency"]),
  },
  {
    title: "Expiry Date",
    dataIndex: "closeDate",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (_, record) => {
      return <Text> {handleFlgStatus(record?.status, {}, true)}</Text>;
    },
  },
];

const handleFlgStatus = (status, style = {}, isListing = false) => {
  switch (status.toLowerCase()) {
    case "active":
      return (
        <Tag
          icon={<CheckCircleOutlined />}
          color={`${isListing ? "success" : "#87D068"}`}
          style={style}
        >
          {status}
        </Tag>
      );
    case "inactive":
      return (
        <Tag
          icon={<CloseCircleOutlined />}
          color={`${isListing ? "red" : "#FA0008"}`}
          style={style}
        >
          {status}
        </Tag>
      );
    default:
      return (
        <Tag
          icon={<ClockCircleOutlined />}
          color={`${isListing ? "warning" : "#FFEB86"}`}
          style={{ color: "black", ...style }}
        >
          {BOM.SubstringFormat(status, 21)}
        </Tag>
      );
  }
};

const PRD0200 = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { monthList, loanStatusData } = appStatic;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  // const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [loanProductList, setLoanProductList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  useEffect(() => {
    BOM.HasPermission("READ_LOANPRODUCT") && getLoanProductListAction();
    BOM.HasPermission("CREATE_LOANPRODUCT") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  //DECLARED METHODS
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    // console.log(searchKey);

    if (!searchKey) {
      setLoanProductList(loanProductList);
      return;
    }
    // console.log(originalList);
    const filterBySearch = loanProductList.filter(
      (item) =>
        item?.name.toLowerCase()?.includes(searchKey.toLowerCase()) ||
        item?.shortName.toLowerCase()?.includes(searchKey.toLowerCase()) ||
        item?.currency.toLowerCase()?.includes(searchKey.toLowerCase())
    );
    // console.log(filterBySearch);
    setLoanProductList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  const getLoanProductListAction = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetLoanProductList, (err, res) => {
      console.log(res);
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          const cleanedStatus =
            element?.status?.replace("loanProduct.", "") || "-";
          tempArray.push({
            key: element?.id,
            name: element?.name ? element?.name : "-",
            shortName: element?.shortName ? element?.shortName : "-",
            closeDate: element?.closeDate
              ? `${element?.closeDate[2]} ${
                  monthList[element?.closeDate[1] - 1]
                } ${element?.closeDate[0]}`
              : "-",
            currency: element?.currency ? element?.currency?.displayLabel : "-",
            status:
              cleanedStatus !== "-"
                ? cleanedStatus.charAt(0).toUpperCase() + cleanedStatus.slice(1)
                : "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setLoanProductList(tempArray.filter((item) => item.disabled === false));
        setLoanProductList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };
      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, definedApi.GetLoanProductList, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            const cleanedStatus =
              element?.status?.replace("loanProduct.", "") || "-";
            tempArray.push({
              key: element?.id,
              name: element?.name ? element?.name : "-",
              shortName: element?.shortName ? element?.shortName : "-",
              closeDate: element?.closeDate
                ? `${element?.closeDate[2]} ${
                    monthList[element?.closeDate[1] - 1]
                  } ${element?.closeDate[0]}`
                : "-",
              currency: element?.currency
                ? element?.currency?.displayLabel
                : "-",
              status:
                cleanedStatus !== "-"
                  ? cleanedStatus.charAt(0).toUpperCase() +
                    cleanedStatus.slice(1)
                  : "-",
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    // console.log(selectedRowKeys);
    // console.log(objParam);

    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_LOANPRODUCT") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_LOANPRODUCT") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-prd0200", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-prd0200", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-prd0200", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={appLabel.LoanProduct}
        pageItems={appStatic.LoanProductItems}
      />

      <Card
        title={`${appLabel.LoanProduct} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name..."
                style={{
                  width: 400,
                }}
              />
            </div>
            <StatusSelect
              statusOptions={loanStatusData}
              originalList={originalList}
              onFilteredListChange={setLoanProductList}
              statusField="status"
            />
            <DownloadTableButtons
              downloadData={loanProductList}
              columns={columns}
              fileName={"Loan Product List"}
              onExportClick={getCsvListData}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={loanProductList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(PRD0200);
